import "./BlogScreen.scss";
import { Fragment, useEffect, useState } from "react";
import BlogCard from "../../../components/blogCard/BlogCard";
import { IoSearchSharp } from "react-icons/io5";
import Pagination from "@mui/material/Pagination";

const BlogScreen = ({
  dataList,
  categoryList,
  setSearch,
  search,
  categoryId,
  setCategoryId,
}) => {
  const [page, setPage] = useState(1);

  const itemsPerPage = 4;

  const category = [
    {
      id: 0,
      title: "Education",
      num: "03",
    },
    {
      id: 1,
      title: "Hetalth care",
      num: "07",
    },
    {
      id: 2,
      title: "Food and water",
      num: "09",
    },
    {
      id: 3,
      title: "Chemistry",
      num: "01",
    },
    {
      id: 4,
      title: "UI/UX Deisgn",
      num: "00",
    },
    {
      id: 5,
      title: "Gemological",
      num: "26",
    },
  ];

  const pageChange = (e, value) => {
    setPage(value);
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [page]);

  const searchHandler = (e) => {
    setSearch(e.target.value);
  };
  return (
    <section className="blog_screen">
      <div className="content_wrap p_t p_b">
        <div className="bi_grid">
          <div className="blog_list">
            {dataList?.length > 0 ? (
              <Fragment>
                {dataList
                  ?.slice(
                    page * itemsPerPage - itemsPerPage,
                    page * itemsPerPage
                  )
                  ?.map((data) => {
                    return (
                      <Fragment key={data?._id}>
                        <BlogCard data={data} />
                      </Fragment>
                    );
                  })}
                {dataList.length > itemsPerPage && (
                  <div className="pagination_wrap mt-5">
                    <Pagination
                      count={Math.ceil(dataList.length / itemsPerPage)}
                      onChange={pageChange}
                      shape="rounded"
                    />
                  </div>
                )}
              </Fragment>
            ) : (
              <p className="text-center">Data not found...</p>
            )}
          </div>
          <div className="filter_wrap">
            <div className="card_wrap search_box">
              <h4>Search Here</h4>
              <div className="inpu_wrap">
                <IoSearchSharp />
                <input
                  type="text"
                  placeholder="SEARCH POST"
                  value={search}
                  onChange={searchHandler}
                />
              </div>
            </div>
            <div className="card_wrap">
              <h4>Categories</h4>
              <div
                className={`tab_wrap ${categoryId === "" ? "active" : ""}`}
                onClick={() => setCategoryId("")}
              >
                <p className="t_16">All</p>
                <p className="t_16">{categoryList?.reduce((total, ele) => total + ele?.totalblogs, 0)}</p>
              </div>
              {categoryList?.map((data, k) => {
                return (
                  <div
                    className={`tab_wrap ${
                      categoryId === data?._id ? "active" : ""
                    }`}
                    key={data?._id}
                    onClick={() => setCategoryId(data?._id)}
                  >
                    <p className="t_16">{data?.name}</p>
                    <p className="t_16">{data?.totalblogs}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogScreen;
